import React from 'react'
import { AppButton } from '@easyllama/ui-components'
import { cn } from '~/utils/commonUtils'

export default function ContactSalesButton({ className = '', size = 'default', ...props }) {
  return (
    <AppButton
      variant='outline'
      size={size}
      className={cn('text-llama-grey-7', className)}
      {...props}
    >
      Contact sales
    </AppButton>
  )
}
